<div #chartDiv [id]="chartdiv_id" class = "clustered-column-chart"></div>